/* TUI Scroll-Reveal — REMOVED (2026-06): elements now load statically, no float-up.
   The reveal hid content (opacity:0 -> 600ms fade + per-item stagger) until it
   scrolled into view, which delayed paint on fast carousel swipes and value-prop
   text, and could trap content at opacity:0. Removing it improves LCP / perceived
   speed. The micro-interactions below are unchanged. */

/* TUI Product Card — Mobile image swipe (touch only)
   Swipe left/right toggles secondary image. Tap navigates to PDP. */
(function(){
  if(!window.matchMedia('(pointer: coarse)').matches) return;

  var SWIPE_THRESHOLD = 30;

  function setup(){
    document.querySelectorAll('.product-card__figure').forEach(function(fig){
      if(fig._tuiSwipe) return;
      if(!fig.querySelector('.product-card__image--secondary')) return;
      fig._tuiSwipe = true;

      var startX = 0, startY = 0, tracking = false;

      fig.addEventListener('touchstart', function(e){
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, {passive: true});

      fig.addEventListener('touchmove', function(e){
        if(!tracking) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        /* If vertical scroll dominates, bail out */
        if(Math.abs(dy) > Math.abs(dx)){
          tracking = false;
          return;
        }
        if(Math.abs(dx) > SWIPE_THRESHOLD){
          e.preventDefault();
          tracking = false;
          if(dx < 0){
            fig.classList.add('tui-show-secondary');
          } else {
            fig.classList.remove('tui-show-secondary');
          }
        }
      }, {passive: false});

      fig.addEventListener('touchend', function(){
        tracking = false;
      }, {passive: true});
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();

  /* Re-run after Shopify section renders (e.g. quick view, AJAX pagination) */
  new MutationObserver(function(){ setup(); }).observe(document.body, {childList: true, subtree: true});
})();

/* TUI Delegated handlers — password show/hide + manage-cookies */
(function() {
  document.addEventListener('click', function(e) {
    /* Password show/hide toggle */
    var toggleBtn = e.target.closest('[data-action="toggle-password"]');
    if (toggleBtn) {
      var input = toggleBtn.previousElementSibling;
      if (!input || (input.type !== 'password' && input.type !== 'text')) return;
      var show = input.type === 'password';
      input.type = show ? 'text' : 'password';
      toggleBtn.setAttribute('aria-pressed', show ? 'true' : 'false');
      toggleBtn.setAttribute('aria-label', show
        ? (toggleBtn.dataset.labelHide || 'Hide password')
        : (toggleBtn.dataset.labelShow || 'Show password')
      );
      var iconShow = toggleBtn.querySelector('.input__password-toggle-icon--show');
      var iconHide = toggleBtn.querySelector('.input__password-toggle-icon--hide');
      if (iconShow) iconShow.hidden = show;
      if (iconHide) iconHide.hidden = !show;
    }

    /* Manage cookies — clear consent and reload */
    if (e.target.closest('[data-action="manage-cookies"]')) {
      e.preventDefault();
      document.cookie = 'tui_consent=; Max-Age=0; Path=/';
      location.reload();
    }
  });

  /* Checkout button loading state — prevent double-submit */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.getAttribute('action') !== '/cart') return;
    var btn = form.querySelector('[name="checkout"], button[type="submit"]');
    if (!btn) return;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    var originalText = btn.textContent;
    btn.textContent = btn.dataset.loadingText || 'Processing…';
    /* Restore if navigation is cancelled (e.g. back button) */
    window.addEventListener('pageshow', function() {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.textContent = originalText;
    }, { once: true });
  });
})();
